import React, { useState } from 'react';
import './App.css';
import { login, getMembers } from './api/api';  // Importiere die API-Funktionen

function App() {
  const [token, setToken] = useState('');
  const [members, setMembers] = useState([]);

  // Login-Funktion
  const handleLogin = async () => {
    try {
      const token = await login('100411', '5bf425da00416db640168bd4ca1bff00');
      setToken(token);
      console.log('Login erfolgreich:', token);
    } catch (error) {
      console.error('Login fehlgeschlagen:', error);
    }
  };

  // Mitglieder abrufen
  const handleGetMembers = async () => {
    try {
      const members = await getMembers(token);
      setMembers(members);
    } catch (error) {
      console.error('Fehler beim Abrufen der Mitglieder:', error);
    }
  };

  return (
    <div className="App">
      <h1>Willkommen zu XtraSport</h1>
      <button onClick={handleLogin}>Mitglied anmelden</button>
      {token && <p>Token erhalten: {token}</p>}
      <button onClick={handleGetMembers} disabled={!token}>Mitglieder abrufen</button>
      <div>
        <h3>Mitgliederliste:</h3>
        <ul>
          {members.map((member) => (
            <li key={member.id}>{member.name} - {member.street}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default App;